import { Song } from "@/types/types";

const songKey = (song: Song): string =>
    String(song?.id || (song as any)?.song_id || "").trim();

export const applyCompactVoteUpdate = (
    songs: Song[],
    songId: string,
    votes: number,
    position: number,
    currentSongId?: string | null,
): Song[] => {
    const targetId = String(songId || "").trim();
    const currentId = String(currentSongId || "").trim();
    const updated = songs.map((song) =>
        songKey(song) === targetId ? { ...song, votes: Number(votes || 0) } : song
    );
    const current = currentId ? updated.find((song) => songKey(song) === currentId) : undefined;
    const queue = updated.filter((song) => song !== current);
    const targetIndex = queue.findIndex((song) => songKey(song) === targetId);
    if (targetIndex < 0) return updated;
    const [target] = queue.splice(targetIndex, 1);
    queue.splice(Math.max(0, Math.min(Number(position) || 0, queue.length)), 0, target);
    return current ? [current, ...queue] : queue;
};

export const applyOptimisticVote = (
    songs: Song[],
    songId: string,
    amount: number,
    currentSongId?: string | null,
): { songs: Song[]; position: number } => {
    const targetId = String(songId || "").trim();
    const currentId = String(currentSongId || "").trim();
    const updated = songs.map((song) =>
        songKey(song) === targetId
            ? { ...song, votes: Number(song.votes || 0) + Number(amount || 0) }
            : song
    );
    const current = currentId ? updated.find((song) => songKey(song) === currentId) : undefined;
    const queue = updated.filter((song) => song !== current);
    const ordered = queue
        .map((song, index) => ({ song, index }))
        .sort((left, right) =>
            Number(right.song.votes || 0) - Number(left.song.votes || 0) || left.index - right.index
        )
        .map(({ song }) => song);
    return {
        songs: current ? [current, ...ordered] : ordered,
        position: ordered.findIndex((song) => songKey(song) === targetId),
    };
};

export const shouldReconcileQueueRevision = (lastRevision: number, nextRevision: number): boolean =>
    nextRevision > lastRevision + 1;
